import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup
    .object()
    .shape({
      locationName: yup.string().nullable(),
      locationNumber: yup.array().nullable(),
      isDefaultLocation: yup.string().nullable(),
      city: yup.string().nullable(),
      state: yup.object().nullable(),
      postalCode: yup.string().nullable(),
      status: yup.string().nullable(),
    })
    .test(
      'at-least-one-required',
      formatMessage({
        id: 'AT_LEAST_ONE_FIELD_IS_REQUIRED',
        defaultMessage: 'At least one field is required',
      }),
      value => {
        const { serviceProviderId, ...newValues } = value;
        return newValues &&
          typeof newValues === 'object' &&
          Object.values(newValues).length > 0 &&
          !Array.isArray(newValues)
          ? Object.values(newValues).some(val => val && val !== '')
          : false;
      },
    );

export default validationSchema;
